import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';

import React, { useState} from 'react';
import './ChartPage.css';
import Client from '../../components/Websocket/Client';
import MACDHistogramChart from '../../components/ChartComponent/MACDHistChart';


const ChartPage = () => {
  const [csvData, setCSVData] = useState(null);
  const handleCSVUpload = (data) => {
    console.log("csvData", data)
    setCSVData(data);
  };

  return (
    <Container>


      {/* <CSVUploadComponent onUpload={handleCSVUpload} /> */}
      <Grid item xs={12} md={8} lg={9}>
        <Paper
          sx={{
            p: 2,
            display: 'flex',
            flexDirection: 'column',
            height: 320,
          }}
        >
          <div className="chart-page">
            <div className="chart-component">

              {/* {csvData && <ChartComponent rawData={csvData} />} */}
              
            </div>
          </div>

        </Paper>
      </Grid>
      <Paper
        sx={{
          p: 2,
          display: 'flex',
          flexDirection: 'column',
          height: 400,
        }}
      >
        <div className="chart-page">
          <div className="chart-component">

            {/* <TradingChart /> */}
            {/* <MinuteChart/> */}
          </div>
        </div>

      </Paper>
      
      <Paper
        sx={{
          p: 2,
          display: 'flex',
          flexDirection: 'column',
          height: 400,
        }}
      >
        <div className="chart-page">
          <div className="chart-component">

            <Client />

            {/* <MACDHistogramChart/> */}
          </div>
        </div>

      </Paper>

      <Paper
        sx={{
          p: 2,
          display: 'flex',
          flexDirection: 'column',
          height: 400,
        }}
      >
        <div className="chart-page">
          <div className="chart-component">
          {/* <Chart priceData={candles} volumeData={volume}></Chart> */}
          </div>
        </div>

      </Paper>
      
    </Container>



  );
};

export default ChartPage;
